import { Component, computed, inject, input, output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { TableColumn, TableColumnType } from '../../../../shared/components/kit/table/table.types';
import {
    PersonAuthorizationDialogData,
    PersonAuthorizationsDialogComponent,
} from '../person-authorizations-dialog/person-authorizations-dialog.component';
import { PersonAuthorizationsStore } from './person-authorizations.store';
import { FilterInput } from '@it2go/data-grid';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import { PersonContactTypeEnum } from '../../../../../../../../types/src/services/enum/person-contact-type.enum';
import { userClientChipColumn } from '../../../../shared/components/kit/table/table.fields';
import { personContactFrag } from './person-authorizations.query';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-person-authorizations',
    templateUrl: './person-authorizations.component.html',
    styleUrls: ['./person-authorizations.component.scss'],
    providers: [PersonAuthorizationsStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardTableComponent,
        PrimeTemplate,
        TranslatePipe,
    ],
})
export class PersonAuthorizationsComponent {

    public readonly dialogService = inject(BaseDialogService);
    public readonly confirm = inject(ConfirmBuilder);
    public readonly store = inject(PersonAuthorizationsStore);

    public personId = input<number | null>(null);
    public canEdit = input(true);

    protected personAuthorizationTable = viewChild<TableComponent>('personAuthorizationTable');

    public created = output<any>();

    protected items: any[] = [];

    protected additionalFilters = computed<FilterInput[][]>(() => [
        [{
            column: 'type',
            operator: 'EQ',
            value: [PersonContactTypeEnum.AUTHORIZATION],
        }],
        [{
            column: 'personId',
            operator: 'eq',
            value: [String(this.personId() || '0')],
        }],
    ]);

    protected columns: TableColumn[] = [
        {
            name: 'validFrom',
            type: TableColumnType.Date,
            filterable: undefined,
        },
        {
            name: 'validTo',
            type: TableColumnType.Date,
            filterable: undefined,
        },
        {
            ...userClientChipColumn,
            name: 'representsPerson',
            dataKey: 'user',
        },
        {
            name: 'authorizationType',
        },

    ];

    constructor() {
        this.store.onSuccess(
            () => this.personAuthorizationTable()?.reload(),
            'createPersonContact',
            'updatePersonContact',
            'deletePersonContact',
        );
    }

    protected async personAuthorizationsDetail(item?: any): Promise<void> {
        const data: PersonAuthorizationDialogData = item ? {
            authorization: item,
            personId: this.personId(),
        } : { personId: this.personId() };

        this.dialogService.open(PersonAuthorizationsDialogComponent, {
            maximizable: true,
            data: data,
        }).onClose.subscribe((it) => {
            if (!it) return;

            this.created.emit(it);

            this.items = !this.personId() ? [
                ...this.items,
                it,
            ] : [];
        });
    }

    protected deletePersonAuthorization(item: any): void {
        this.confirm.confirmDelete(
            () => {
                if (this.personId()) {
                    this.store.api.deletePersonContact({ id: item.item.id });
                } else {
                    this.items = [...this.items.filter((_, index) => index !== item.rowIndex)];
                }
            },
            item,
        );
    }

    protected readonly personContactFrag = personContactFrag;
}
